import { DateTime } from 'luxon';

function dateTimeToRelative(dateString: string | DateTime | Date, locale: string): string | undefined {
  const date =
    dateString instanceof Date
      ? dateString.getTime()
      : dateString instanceof DateTime
        ? dateString.valueOf()
        : new Date(dateString).getTime();
  const now = new Date().getTime();

  const diffInSeconds = Math.floor((now - date) / 1000);
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });

  if (diffInDays > 1) {
    return;
  }
  if (diffInDays > 0) {
    return rtf.format(-diffInDays, 'day');
  } else if (diffInHours > 0) {
    return rtf.format(-diffInHours, 'hour');
  } else if (diffInMinutes > 0) {
    return rtf.format(-diffInMinutes, 'minute');
  } else {
    return rtf.format(-diffInSeconds, 'second');
  }
}

export function formatDate(
  value: string | undefined | null | DateTime | Date,
  options: {
    format?: Intl.DateTimeFormatOptions;
    locale: string;
    readable?: boolean;
    relative?: boolean;
    suffix?: string;
  },
): string | null {
  const { format = DateTime.DATE_SHORT, locale, readable, relative, suffix = '' } = options;

  if (!value) {
    return null;
  }

  if (relative) {
    const formatted = dateTimeToRelative(value, locale);
    if (formatted) {
      return formatted;
    }
  }

  let formattedDate: string;

  if (readable || relative) {
    formattedDate =
      value instanceof DateTime
        ? value.toLocaleString(DateTime.DATE_SHORT, { locale })
        : (value instanceof Date ? DateTime.fromJSDate(value) : DateTime.fromISO(value)).toLocaleString(
            DateTime.DATE_FULL,
            { locale },
          );
  } else {
    formattedDate =
      value instanceof DateTime
        ? value.toLocaleString(format, { locale })
        : (value instanceof Date ? DateTime.fromJSDate(value) : DateTime.fromISO(value)).toLocaleString(format, {
            locale,
          });
  }

  return `${formattedDate}${suffix}`;
}
